"use client";

import React from "react";
import cx from "classnames";
// import Transition from "../Transition";
import { Transition } from "@headlessui/react";

// "relative isolate
// overflow-hidden
// w-full h-full bg-red-100 rounded-lg before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-linear-to-r before:from-transparent before:via-white/50 before:to-transparent"

// const ShimmerBox = React.forwardRef(({ className, ...props }, ref) => (

// ));

const LoadingSkeleton = ({ className = "", show = true, ...props }) => (
  <Transition
    // as={React.Fragment}
    // key={id}
    // show={showReviewIndex === index}
    show={show}
    enter="transition-opacity duration-300"
    enterFrom="opacity-0"
    enterTo="opacity-100"
    leave="transition-opacity duration-300"
    leaveFrom="opacity-100"
    leaveTo="opacity-0"
    // debug={index === 0}
  >
    <div
      className={cx(
        `relative 
          isolate overflow-hidden
          w-full h-full bg-neutral-200
          rounded-lg
          
          before:absolute before:inset-0
          before:-translate-x-full before:animate-[shimmer_2s_infinite]
          before:bg-linear-to-r before:from-transparent before:via-white/50 before:to-transparent`,
        className,
      )}
      // ref={ref}
      {...props}
    ></div>
  </Transition>
);

export default LoadingSkeleton;
